module.exports = __webpack_public_path__ + "static/media/flecha_al_lado.f2053cf5.svg";